import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Feed from "@/pages/Feed";
import Publish from "@/pages/Publish";
import Planned from "@/pages/Planned";
import RideDetail from "@/pages/RideDetail";
import EditRide from "@/pages/EditRide";
import Profile from "@/pages/Profile";
import PublicProfile from "@/pages/PublicProfile";
import AuthCallback from "@/pages/AuthCallback";
import GoogleAuthCallback from "@/pages/GoogleAuthCallback";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-10 h-10 border-2 border-[#E11D48] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback fragment synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/google" element={<GoogleAuthCallback />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/feed" element={<Feed />} />
      <Route path="/ride/:id" element={<RideDetail />} />
      <Route path="/publish" element={<ProtectedRoute><Publish /></ProtectedRoute>} />
      <Route path="/planned" element={<ProtectedRoute><Planned /></ProtectedRoute>} />
      <Route path="/ride/:id/edit" element={<ProtectedRoute><EditRide /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/u/:userId" element={<PublicProfile />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#171717", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
